import { render, staticRenderFns } from "./ProductTree.vue?vue&type=template&id=5e87d89e&scoped=true&"
import script from "./ProductTree.vue?vue&type=script&lang=js&"
export * from "./ProductTree.vue?vue&type=script&lang=js&"
import style0 from "./ProductTree.vue?vue&type=style&index=0&id=5e87d89e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e87d89e",
  null
  
)

export default component.exports